import get from 'lodash/get';
import { CONSTANTS } from './Configuration';
import { navigateQuestions } from './ApplicationHelpers';

// Returns values selected in other repetitions of the same type field within the same section.
export const getSameRepetitionExcludedValues = ({ isRepeatingTypeField, repetition, prefix, formValues, questionId }) => {
    if (!isRepeatingTypeField || repetition === undefined) return [];
    const parts = prefix?.split('.') || [];
    if (parts.length !== 3) return [];
    const [pageId, sectionId] = parts;
    const sectionValues = get(formValues, [pageId, sectionId]);
    if (!Array.isArray(sectionValues)) return [];
    return sectionValues
        .filter((repValue, index) => index !== repetition && repValue?.[questionId])
        .map(repValue => repValue[questionId]);
};

// Returns values selected in the related cross-field type (nameType - alternateNameType).
export const getCrossFieldExcludedValues = ({ question, prefix, formValues, template }) => {
    const attr = question.eedmDestinationAttribute;
    const relatedAttr = attr && CONSTANTS.relatedTypeFieldAttributes?.[attr];
    if (!relatedAttr || !template || !formValues) return [];
    const pageId = prefix?.split('.')?.[0];
    if (!pageId) return [];
    const excludedValues = [];
    navigateQuestions(template, (_p, s, _g, q) => {
        if (q.eedmDestinationAttribute === relatedAttr) {
            if (s.showRepetition) {
                // Repeating section: values at formValues[pageId][sectionId][index][questionId]
                const sectionValues = get(formValues, [pageId, s.id]);
                if (Array.isArray(sectionValues)) {
                    sectionValues.forEach(repValue => {
                        const val = repValue?.[q.id];
                        if (val) excludedValues.push(val);
                    });
                }
            } else {
                // when the related field is not repeating get the values at this path - formValues[pageId][questionId]
                const val = get(formValues, [pageId, q.id]);
                if (val) excludedValues.push(val);
            }
        }
    });
    return excludedValues;
};